import gql from 'graphql-tag'

export default gql`
query listOrderTypes($params: ListQueryArgs) {
	cashAssist {
		listOrderTypes(params: $params) {
			items {
                id
                mod_ver
                code
                name
			}
			hasNextPage
		}
	}
}`
